<template>
  <PrimeBadge :value="value" :severity="severity" :size="size" />
</template>

<script setup lang="ts">
import PrimeBadge from 'primevue/badge';

defineProps<{
  value?: string | number;
  severity?: string;
  size?: string;
}>();
</script>
